import type { QuickSuggestion, ContactCTA } from '@/types/chatbot'

export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'breweries',
    labelKey: 'chatbot.suggestions.breweries',
    messageKey: 'chatbot.suggestions.breweriesMessage',
  },
  {
    id: 'products',
    labelKey: 'chatbot.suggestions.products',
    messageKey: 'chatbot.suggestions.productsMessage',
  },
  {
    id: 'contacts',
    labelKey: 'chatbot.suggestions.contacts',
    messageKey: 'chatbot.suggestions.contactsMessage',
  },
  {
    id: 'workWithUs',
    labelKey: 'chatbot.suggestions.workWithUs',
    messageKey: 'chatbot.suggestions.workWithUsMessage',
  },
]

export const contactCTAs: ContactCTA[] = [
  {
    id: 'phone',
    labelKey: 'chatbot.cta.phone',
    url: 'tel:+390499099111',
  },
  {
    id: 'email',
    labelKey: 'chatbot.cta.email',
    url: 'mailto:info@interbrau.it',
  },
]
